import React, { useState, useEffect } from 'react';
import { generatePointsArray, getLanguageArray, Language, levelLabel, levelUpLabel, systemLanguage } from '../../utils/constants';
import style from './style.module.css';

import { sysLabels } from '../../data/translations';

import useUserPoints from '../../hooks/useUserPoints';
import useUserLevel from './../../hooks/useUserLevel';

import Icons from '../Icons/Icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Point {
    max: number;
    level: number;
}

interface ProgressProps {
    gold: boolean;
    icon: IconProp;
}

const ProgressBar: React.FC<ProgressProps> = ({gold,icon}) => {
    const currentPoints = useUserPoints();
    const findMaxAndMinValue = (points: Point[], currentPoints: number): { max: number, prevMax: number } => {
        let prevMax = 0;
        for (const point of points) {
            if (point.max > currentPoints) {
                return { max: point.max, prevMax };
            }
            prevMax = point.max;
        }
        return { max: points[points.length - 1].max, prevMax };
    };

    const points = generatePointsArray(250, 1000);
    const { max, prevMax } = findMaxAndMinValue(points, currentPoints);

    const progress = ((currentPoints - prevMax) / (max - prevMax)) * 100;

    const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

    const level = useUserLevel()
    const nextLevel = level+1;

    const untilNextLevel = max-currentPoints;

    useEffect(() => {
        const handler = (e: StorageEvent) => {
            if (e.key === systemLanguage && e.newValue) {
                setSessionLang(JSON.parse(e.newValue));
            }
        };
        window.addEventListener("storage", handler);
        return () => window.removeEventListener("storage", handler);
    }, []);

    return (
        <>
        <div className={`${style.levelNumber} ${gold?style.gold:''}`}>
            <Icons icon={icon} /><span>{level}</span>
        </div>
        <div className={style.levelText}>
            {sysLabels[levelLabel][((sessionLang as unknown) as Language).short || 'EN']}.{level} - {sysLabels[levelLabel][((sessionLang as unknown) as Language).short || 'EN']}.{nextLevel}
        </div>
        <div style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '5px', overflow: 'hidden' }}>
            <div
                style={{
                    width: `${progress}%`,
                    height: '20px',
                    backgroundColor: '#FFF',
                    transition: 'width 0.3s ease-in-out'
                }}
            />
        </div>
        <div className={`${style.levelText} ${style.levelUpText}`}>
            {untilNextLevel} {sysLabels[levelUpLabel][((sessionLang as unknown) as Language).short || 'EN']}
        </div>
        </>
    );
};

export default ProgressBar;
